import { useTranslation } from 'react-i18next'
import tableCoinIcon from 'assets/images/coin.svg'
import Table from 'components/Table'
import { createColumnHelper } from '@tanstack/react-table'
import top1Icon from 'assets/images/rankpage-top1.svg'
import top2Icon from 'assets/images/rankpage-top2.svg'
import top3Icon from 'assets/images/rankpage-top3.svg'
import { useQuery } from 'react-query'
import { getRankQuery } from 'dataLayer/game'
import { useState } from 'react'
import { hidePhoneNumberMiddle } from 'utils/helpers'

function RankTable({ time }) {
	const { t } = useTranslation()
	const [paramGetRank, setParamGetRank] = useState({
		offset: 0,
		limit: 10,
	})

	const { data: rank, isLoading } = useQuery(
		getRankQuery(time, paramGetRank.offset, paramGetRank.limit),
	)
	let listRank = (rank && rank.filter(it => it.coin_win !== 0)) || []
	const dataRank = listRank?.map(it => {
		it.msisdn = hidePhoneNumberMiddle(it.msisdn)
		return it
	})

	const columnHelper = createColumnHelper()

	const columns = [
		columnHelper.accessor('id', {
			cell: info => {
				const orderId = parseInt(info.row.id) + 1
				return orderId === 1 ? (
					<img src={top1Icon} width="32" alt="Top 1" />
				) : orderId === 2 ? (
					<img src={top2Icon} width="32" alt="Top 2" />
				) : orderId === 3 ? (
					<img src={top3Icon} width="32" alt="Top 3" />
				) : (
					orderId
				)
			},
			header: () => <span>{t('rankpage.table.rank')}</span>,
			footer: info => info.column.id,
		}),
		columnHelper.accessor(row => row.msisdn, {
			id: t('rankpage.table.player'),
			cell: info => info.getValue(),
			header: () => <span>{t('rankpage.table.player')}</span>,
			footer: info => info.column.id,
		}),
		columnHelper.accessor(row => row.coin_win, {
			id: t('rankpage.table.gold'),
			cell: info => {
				return (
					<div className="betcoin-container">
						<div style={{ display: 'flex', marginLeft: '43%' }}>
							<img src={tableCoinIcon} width="20" alt="Bet's coin" />
							<p style={{ marginLeft: '15%' }}>
								{new Intl.NumberFormat('lo').format(info.getValue())}
							</p>
						</div>
					</div>
				)
			},
			header: () => <span>{t('rankpage.table.gold')}</span>,
			footer: info => info.column.id,
		}),
		columnHelper.accessor(row => `${row.total_win}/${row.total_lose}`, {
			id: t('rankpage.table.winrate'),
			cell: info => info.getValue(),
			header: () => <span>{t('rankpage.table.winrate')}</span>,
			footer: info => info.column.id,
		}),
	]

	return (
		<>
			<Table
				{...{
					data: !isLoading ? dataRank : [],
					columns,
				}}
				rankTable={true}
				setParamGetRank={setParamGetRank}
				paramGetRank={paramGetRank}
			/>
		</>
	)
}

export default RankTable
